export const responsive = {
  mobile: {
    breakpoint: { max: 1030, min: 0 },
    items: 1,
  },
}
